"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateDatabase = void 0;
exports.migrateDatabase = function (database) {
    switch (database.version) {
        case 2:
            return database;
        default:
            return migrations[0](database);
    }
};
var migrations = [
    function (database) {
        var features = {};
        Object.values(database.services).forEach(function (service) {
            features[service.id] = __assign(__assign({}, service), { actors: service.environments, scenarios: service.sequences });
        });
        return {
            version: 2,
            features: features,
        };
    },
];
